import React, { Component } from "react";
import { Link } from "react-router-dom";

export const Breadcrumb = (props) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb pl-0">
        <li className="breadcrumb-item">
          <Link to="/dashboard-report">
            <i className="material-icons">home</i> Home
          </Link>
        </li>

        <li className="breadcrumb-item active" aria-current="page">
          Stock Summary List
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
